import React, { Component } from 'react'

import './index.scss'

import FacebookSVG from 'assets/images/facebook.svg'
import TwitterSVG from 'assets/images/twitter.svg'

class SocialSharingLinks extends Component {
  constructor () {
    super()
    this.state = { someKey: 'someValue' }
  }

  shareOn (sm) {
    let link = window.location
    switch (sm) {
      case 'fb':
        window.open(
          `https://www.facebook.com/dialog/feed?display=popup&app_id=345848789167517&link=${link}`,
          'Facebook',
          'height=580, width=730'
        )
        break
      case 'tw':
        window.open(
          `https://twitter.com/share?url=${link}`,
          'Twitter',
          'height=580, width=730'
        )
        break
    }
  }

  render () {
    return (
      <ul className='social-sharing-links list-unstyled'>
        <li>
          <a onClick={event => this.shareOn('fb')}>
            <img src={FacebookSVG} alt='Share on Facebook' />
          </a>
        </li>
        <li>
          <a onClick={event => this.shareOn('tw')}>
            <img src={TwitterSVG} alt='Share on Twitter' />
          </a>
        </li>
      </ul>
    )
  }

  componentDidMount () {
    this.setState({ someKey: 'otherValue' })
  }
}

export default SocialSharingLinks



// WEBPACK FOOTER //
// ./src/components/SocialSharingLinks/index.js